import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Tabs,
  Tab,
  CircularProgress,
  FormControl,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { getfulFillmentStatus, getFulFillments, updateFulFillmentStatus, updateFulFillmentStatusAndWarehouse, getOrderDetailsFulFillments } from '../service/fulfillmentService';
import warehouseService from '../service/warehouseService'; 

const FulfillmentOrderManager = () => {
  const [tab, setTab] = useState("PENDING");
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statusOptions, setStatusOptions] = useState([]);
    const [warehouses, setWarehouses] = useState([]);
  
        const [detailsLoading, setDetailsLoading] = useState(false);
      const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [orderDetails, setOrderDetails] = useState([]);
  
  // Load fulfillment orders from backend
  const fetchOrders = async () => {
    try {
      setLoading(true);
      const response = await getFulFillments(); //axiosInstance.get("/api/fulfillment-orders"); // 🔹 adjust endpoint
      setOrders(response.data || []);
    } catch (error) {
      console.error("Error fetching fulfillment orders:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
    fetchStatuses();
    fetchWarehouses();
  }, []);

     const fetchStatuses = async () => {
    try {
      const res = await getfulFillmentStatus();
      setStatusOptions(res.data);
    } catch (err) {
      console.error("Error fetching referral statuses", err);
    }
  };
  
  // ✅ Fetch Warehouses
  const fetchWarehouses = async () => {
    try {
      const response = await warehouseService.fetchSupplierWarehouse();
      setWarehouses(response || []); 
    } catch (error) {
      console.error("Error fetching warehouses:", error);
    }
  };
  
  const handleStatusChange = async (fulfillmentOrderId, newStatusId) => {
    try {
      setLoading(true);
     await updateFulFillmentStatus(fulfillmentOrderId,newStatusId);

      // update UI locally
      setOrders((prev) =>
        prev.map((o) =>
          o.fulfillmentOrderId === fulfillmentOrderId
            ? {
                ...o,
                fulfillmentStatusId: newStatusId,
                fulfillmentStatusName: statusMap[newStatusId],
              }
            : o
        )
      );
    } catch (error) {
      console.error("Error updating fulfillment status:", error);
    } finally {
      setLoading(false);
    }
  };

   const handleWarehouseChange = async (fulfillmentOrderId, newWarehouseId) => {
    try {
      setLoading(true);
      await updateFulFillmentStatusAndWarehouse(fulfillmentOrderId,newWarehouseId); 
   

      setOrders((prev) =>
        prev.map((o) =>
          o.fulfillmentOrderId === fulfillmentOrderId
            ? { ...o, warehouseId: newWarehouseId }
            : o
        )
      );
    } catch (error) {
      console.error("Error updating warehouse:", error);
    } finally {
      setLoading(false);
    }
  };

  const statusMap = Object.fromEntries(statusOptions.map((s) => [s.id, s.name]));

  // Filter by current tab
  const filteredOrders = orders.filter(
    (o) => o.fulfillmentStatusName?.toUpperCase() === tab
  );

  
  const fetchOrderDetails = async (fulfillmentOrderId) => {
    setDetailsLoading(true);
    setSelectedOrderId(fulfillmentOrderId);
    try {
      const res = await getOrderDetailsFulFillments(fulfillmentOrderId); // adjust your endpoint
      setOrderDetails(res.data); 
        
    } catch (err) {
      console.error("Error fetching order details:", err);
      setOrderDetails([]);
    } finally {
      setDetailsLoading(false);
    }
  };
  
  
  const columns = [
    { field: "fulfillmentOrderId", headerName: "Fulfillment ID", width: 150 },
    { field: "customerOrderId", headerName: "Customer Order ID", width: 160 },
    {
      field: "warehouseId",
      headerName: "Warehouse",
      width: 220,
      renderCell: (params) => (
        <FormControl fullWidth size="small">
          <Select
            value={params.row.warehouseId || ""}
            onChange={(e) =>
              handleWarehouseChange(
                params.row.fulfillmentOrderId,
                Number(e.target.value)
              )
            }
          >
            {warehouses.map((w) => (
              <MenuItem key={w.warehouseId} value={w.warehouseId}>
                {w.name || `Warehouse #${w.warehouseId}`}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ),
    },
      { field: "slotStartTimeString", headerName: "Delivery Start Time", width: 180 },
      { field: "slotEndTimeString", headerName: "Delivery End Time", width: 180 },
    {
      field: "fulfillmentStatusName",
      headerName: "Status",
      width: 150,
    },
    {
      field: "updateStatus",
      headerName: "Update Status",
      width: 220,
      renderCell: (params) => (
        <FormControl fullWidth size="small">
          <Select
            value={params.row.fulfillmentStatusId || ""}
            onChange={(e) =>
              handleStatusChange(
                params.row.fulfillmentOrderId,
                Number(e.target.value)
              )
            }
          >
            {statusOptions.map((status) => (
              <MenuItem key={status.id} value={status.id}>
                {status.code}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ),
    },
  ];
  
  
  const detailColumns = [
    { field: "orderItemId", headerName: "ID", width: 90 },
    { field: "productName", headerName: "Product", flex: 1 },
    { field: "productVariantName", headerName: "Variant", flex: 1 },
    { field: "quantity", headerName: "Qty", width: 100, align: "center" },
    { field: "warehouseId", headerName: "Warehouse", width: 150 },
    { field: "orderId", headerName: "Order ID", width: 150 },
  ];


  return (
    <Box
      sx={{
        p: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        bgcolor: "#f9fafb",
        minHeight: "100vh",
      }}
    >
      <Paper sx={{ width: "100%", maxWidth: 1200, p: 4, borderRadius: 3 }}>
        <Typography variant="h4" textAlign="center" fontWeight="bold" mb={3}>
          Fulfillment Order Manager
        </Typography>

        {/* Tabs */}
        <Tabs
          value={tab}
          onChange={(e, v) => setTab(v)}
          centered
          sx={{ mb: 3 }}
        >
          <Tab label="Pending" value="PENDING" />
          <Tab label="Processing" value="PROCESSING" />
          <Tab label="Ready For Pickup" value="READY_FOR_PICK" />
          <Tab label="Picked Up" value="PICKED_UP" />
        </Tabs>

        {/* Content */}
        {loading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Box sx={{ height: 420 }}>
              <DataGrid
                rows={filteredOrders}
                getRowId={(row) => row.fulfillmentOrderId}
                columns={columns}
                pageSizeOptions={[5, 10, 20]}
                 onRowClick={(params) => fetchOrderDetails(params.row.fulfillmentOrderId )}
              />
              {filteredOrders.length === 0 && (
                <Typography
                  sx={{
                    textAlign: "center",
                    mt: 3,
                    color: "text.secondary",
                  }}
                >
                  No orders in this status.
                </Typography>
              )}
         
            </Box>

            <Box display="flex" justifyContent="flex-end" mt={3}>
              <Button
                variant="contained"
                onClick={fetchOrders}
                disabled={loading}
              >
                Refresh
              </Button>
              
            </Box>
            <Box>
            
                   {selectedOrderId && (
        <Paper sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom>
            Order Details — ID #{selectedOrderId}
          </Typography>
          {detailsLoading ? (
            <CircularProgress />
          ) : orderDetails.length > 0 ? (
            <DataGrid
              rows={orderDetails}
             getRowId={(row) => row.productVariantId} 
              columns={detailColumns}
              autoHeight
            />
          ) : (
            <Typography color="text.secondary">
              No details available for this order.
            </Typography>
          )}
        </Paper>
      )}
            </Box>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default FulfillmentOrderManager;
